(function() {
  exports.PlantingPlanHybrid = (function() {
    PlantingPlanHybrid.prototype.id = null;

    PlantingPlanHybrid.prototype.fieldID = null;

    PlantingPlanHybrid.prototype.hybridID = null;

    PlantingPlanHybrid.prototype.hybridName = '';

    PlantingPlanHybrid.prototype.treatmentID = null;

    PlantingPlanHybrid.prototype.treatmentName = '';

    PlantingPlanHybrid.prototype.units = 0;

    function PlantingPlanHybrid(hybrid, id) {
      if (id == null) {
        id = null;
      }
      if (!((hybrid != null) && hybrid instanceof Object)) {
        return this.error('No hybrid given.', hybrid);
      }
      if ((id != null) && parseInt(id)) {
        this.id = parseInt(id);
        if ((hybrid.id != null) && (hybrid.hybridID == null)) {
          hybrid.hybridID = hybrid.id;
        }
      } else if ((hybrid.id != null) && parseInt(hybrid.id)) {
        this.id = parseInt(hybrid.id);
      } else {
        return this.error('No planting plan ID given.', hybrid);
      }
      if ((hybrid.fieldID != null) && parseInt(hybrid.fieldID)) {
        this.fieldID = parseInt(hybrid.fieldID);
      } else {
        return this.error('No field ID given.', hybrid);
      }
      if ((hybrid.hybridID != null) && parseInt(hybrid.hybridID)) {
        this.hybridID = parseInt(hybrid.hybridID);
      } else {
        return this.error('No hybrid ID given.', hybrid);
      }
      if (hybrid.hybridName != null) {
        this.hybridName = hybrid.hybridName;
      } else if (hybrid.hybrids_name) {
        this.hybridName = hybrid.hybrids_name;
      } else {
        return this.error('No hybrid name given.', hybrid);
      }
      if ((hybrid.treatmentID != null) && parseInt(hybrid.treatmentID)) {
        this.treatmentID = parseInt(hybrid.treatmentID);
      } else if (hybrid.treatments_id != null) {
        this.treatmentID = parseInt(hybrid.treatments_id);
      }
      if (hybrid.treatmentName != null) {
        this.treatmentName = hybrid.treatmentName;
      } else if (hybrid.treatments_name != null) {
        this.treatmentName = hybrid.treatments_name;
      } else if (this.treatmentID != null) {
        return this.error('No treatment name given.', hybrid);
      }
      if ((hybrid.units != null) && parseInt(hybrid.units)) {
        this.units = parseInt(hybrid.units);
      } else {
        return this.error('No units given.', hybrid);
      }
      this.displayName = this.hybridName + (this.treatmentID != null ? ' w/ ' + this.treatmentName : '');
    }

    PlantingPlanHybrid.prototype.get = function() {
      var obj;
      obj = {
        id: this.id,
        fieldID: this.fieldID,
        hybridID: this.hybridID,
        hybridName: this.hybridName,
        treatmentID: this.treatmentID,
        treatmentName: this.treatmentName,
        displayName: this.displayName,
        units: this.units
      };
      return obj;
    };

    PlantingPlanHybrid.prototype.getHybrid = function() {
      var obj;
      obj = {
        id: this.hybridID,
        hybridName: this.hybridName,
        treatmentID: this.treatmentID,
        treatmentName: this.treatmentName,
        displayName: this.displayName
      };
      return obj;
    };

    PlantingPlanHybrid.prototype.error = function(msg, obj) {
      if (obj == null) {
        obj = null;
      }
      debugLog('Failed to create PlantingPlanHybrid object. ' + msg);
      if (obj != null) {
        debugLog(obj);
      }
      return null;
    };

    return PlantingPlanHybrid;

  })();

}).call(this);
